<template>
  <base-content section="small">
    <div class="row">
      <div class="col-12 pb-3">
        <h2 class="font-weight-semibold">
          Hi {{ $auth.user.profile.firstName }},
        </h2>
        <p class="lead">
          Welcome to your Saxon Trust Capital trading dashboard.
        </p>
      </div>
      <div class="col-12">
        <profile-completeness class="mb-5" />
      </div>
      <div class="col-sm-4">
        <user-account-balance />
        <user-account-invested />
      </div>
      <div class="col-sm-8">
        <user-portfolio />
        <investment-portfolio-opportunities />
        <investment-co-funding-opportunities v-if="$auth.user.hasCofundingAccess" />
      </div>
    </div>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import InvestmentCoFundingOpportunities from './InvestmentCoFundingOpportunities.vue'
import InvestmentPortfolioOpportunities from './InvestmentPortfolioOpportunities.vue'
import ProfileCompleteness from './ProfileCompleteness.vue'
import UserAccountBalance from './UserAccountBalance.vue'
import UserAccountInvested from './UserAccountInvested.vue'
import UserPortfolio from './UserPortfolio.vue'

export default {
  name: 'InvestorDashboard',

  components: {
    InvestmentCoFundingOpportunities,
    InvestmentPortfolioOpportunities,
    ProfileCompleteness,
    UserAccountBalance,
    UserAccountInvested,
    UserPortfolio
  },

  computed: {
    ...mapState({
      transactions: store => store.core.transactions.rows
    })
  }
}
</script>
